import React, { useEffect } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


const TABLE_HEAD = ["#","شماره", "نوعيت مکتوب", "عنوان", "مرجع", "تاريخ مکتوب", "فایل‌ها", 'زون', 'تاریخ آپلود', 'اقدامات'];
const breadcrumbs = [{ name: 'آرشیف', link: '/archives' }, { name: 'لیست آرشيف', link: '/list_archive/0' }]
const menuData = [

    { flag: "Edit", name: 'ويرايش', icon: 'create-outline', roles: [1, 2, 19] },
    { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1, 2, 19] },
]


const searchInputFields = [
    { label: 'عنوان', name: 'name', type: 'text', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'نوعيت مکتوب', name: 'doc_type', type: 'select', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'زون', name: 'zone', type: 'select', roles: [1,2], icon: 'text-outline', className: 'md:col-span-2', options: []},
    { label: 'شماره', name: 'number', type: 'text', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },
    { label: ' مرجع', name: 'reference', type: 'text', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'تاريخ آپلود', name: 'created_at', type: 'pdate', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'موقعيت', name: 'physical_location', type: 'text', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },


];


export default function ArchiveList() {
    const { id } = useParams();
    const { com, auth, setModel, models, navigate, generatePDF, setShowFilesModal, setShowViewDialog, showDeleteDialog, setShowDeleteDialog, } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1, 2, 19])) {
            return navigate("/db/notAllowed")
        }
    }, [])


    const handleMenu = (model, flag = false) => {
        console.log("handleMenu ", model, flag, generatePDF);

        if (flag === 'delete') {
            setModel(model)
            setShowDeleteDialog(!showDeleteDialog)
        }
        if (flag === 'edit') {
            gotoEditPage(model);
        }
        if (flag === 'view') {
            setModel(model)
            setShowViewDialog(true)
        }

    };

    const gotoEditPage = (model) => {
        setModel(model)
        navigate(`/db/archives/new_archive/${model.id}`, { state: { modelName: { name: 'archives', af: 'ارشيف' }, model } })
    }

    const openArchiveFilesModel = (model) => {
        if (model?.attachments?.length > 0) {
            setModel(model)
            setShowFilesModal(true)
        }
    }



    const handleViewDialog = (obj) => {
        return [
            { l: 'Name', v: obj?.name },
            { l: 'Type', v: obj?.parent?.label },
            { l: 'Description', v: obj?.description },
            { l: 'Added by', v: obj?.user?.full_name },
            { l: 'Status', v: obj?.status },
            { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
        ]
    }


    const getTableData = () => {
        return (<tbody className=''>
            {models?.data?.map((r, i) => {
                return (
                    <tr key={i}>
                        <td >{models?.from + i}</td>
                        <td >{r?.number}</td>
                        <td>{r?.doc_type?.label}</td>
                        <th>{r?.name}</th>
                        <td>{r?.reference}</td>
                        <td>{r?.from_date}</td>

                        <td> <span className=' cursor-pointer text-blue-600' onClick={() => openArchiveFilesModel(r)}>({r?.attachments?.length})</span></td>

                        <td>{r?.zone?.label}</td>
                        <td >{com.dateConvert(r?.created_at, false, true)}
                            <p>{r?.user?.full_name}</p>
                        </td>
                        <td >
                            <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData, callFrom: 'archives' }} />

                        </td>
                    </tr>
                )
            })}
        </tbody>)
    }



    return (
        <>
            <MainSection v={{
                handleViewDialog,
                newModelInputFields: [{ test: "new page" }],
                searchInputFields,
                TABLE_HEAD,
                breadcrumbs,
                tableData: getTableData(),
                addNewItemTitle: "آپلود فایل جديد",
                tableTitle: 'Archive List',
                url: "list_archives",
                mUrl: { delete: 'archives', create: 'archives', getAll: 'archivesAdvanceSearch' },
                advanceSearch: 'archivesAdvanceSearch',
                modelScreen: '',
                newModelDialogClassName: "h-[90%]",
                searchData: { doc_type: { value: id } }
            }} />

            <ToastContainer />
        </>

    )

}
